import { DatePicker, Select, Input, Form, Col, Row } from "antd";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { isAuthenticated } from "../Auth/auth";
import DragUpload from "../DragUpload/DragUpload";
import { Error, Success } from "../Messages/Messages";
import "./Projects.css";
import MainButtonComp from "../Buttons/MainButtonComp";
import TextArea from "antd/es/input/TextArea";
import GeneralModal from "../../serviceProvider/components/General.modal";
import { SocketContext } from "../../context/SocketContext";
import { currenciesArray } from "../../utils/currenciesArray";
import dayjs from "dayjs";
import { generalErrorAlert } from "../GeneralErrorAlert";
import InventoryUsage from "../Inventory/InventoryUsage";
import { projectStatusArray } from "../../utils/projectStatusArray";

import { useTranslation } from "react-i18next";
import CustomerBranchPicker from "../Billing/CustomerBranchPicker";
import CustomerSelect from "../Billing/CustomerSelect";
import { findBranch, sameId } from "../Billing/customerBranches";
const EditProjects = ({ inventoryList, data, updateParent }) => {
  const { t } = useTranslation("dashboard");
  let serviceProviderId = isAuthenticated()?.employer?._id
    ? isAuthenticated()?.employer?._id
    : isAuthenticated()?.serviceProviderId;
  const socket = useContext(SocketContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [clientsArray, setClientsArray] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [form] = Form.useForm();
  const [branchSel, setBranchSel] = useState({
    clientBranch: data?.clientBranch || null,
    billTo: data?.billTo || "branch"
  });
  const clientId = Form.useWatch("client", form);
  const selectedClient = clientsArray.find(o => sameId(o.value, clientId))?.customer || null;

  const getEmployees = async () => {
    await axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/employees/employee/creator/${serviceProviderId}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          let makeOptions = res.data?.map(d => ({
            label: d?.firstName + " " + d?.lastName,
            value: d?._id
          }));
          setEmployees(makeOptions);
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        generalErrorAlert(err);
      });
  };

  const getClients = async () => {
    setLoading(true);
    await axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/users/clients/limited`,
        { pageSize: 100000000, pageNo: 0, serviceProvider: serviceProviderId },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      )
      .then(res => {
        setLoading(false);
        if (res.status === 200 || res.status === 304) {
          let makeOptions = res.data?.data?.map(d => ({
            label: d?.firstName + " " + d?.lastName,
            value: d?._id,
            customer: d
          }));
          setClientsArray(makeOptions);
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        setLoading(false);
        if (err.response?.data?.errorMessage) {
          Error(err.response?.data?.errorMessage);
        } else {
          Error(err.message);
        }
      });
  };

  const getDepartments = async () => {
    await axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/departments/limited`,
        { serviceProvider: serviceProviderId, pageSize: 10000000, pageNo: 0 },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      )
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          let makeOptions = res.data?.data?.map(d => ({ label: d?.title, value: d?._id }));
          setDepartments(makeOptions);
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        generalErrorAlert(err);
      });
  };

  useEffect(() => {
    getDepartments();
    getEmployees();
    getClients();
  }, []);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const onFinish = async values => {
    setLoading(true);

    await axios
      .put(
        `${process.env.REACT_APP_BACKEND_URL}/projects/update/${data?._id}`,
        { ...values, clientBranch: branchSel.clientBranch || null, billTo: branchSel.billTo },
        { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }
      )
      .then(res => {
        setLoading(false);
        if (res.status === 200 || res.status === 304) {
          Success(res.data.successMessage);
          handleCancel();
          updateParent();
          socket.emit("refresh service provider data", {
            user: isAuthenticated()?.serviceProviderId
          });
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        setLoading(false);
        generalErrorAlert(err);
      });
  };

  const onChangetab = key => {};

  const items = [
    {
      key: "1",
      label: t("Project"),
      children: (
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            projectName: data?.projectName || null,
            client: data?.client?._id || null,
            priority: data?.priority,
            startDate: data?.startDate ? dayjs(data?.startDate) : null,
            endDate: data?.endDate ? dayjs(data?.endDate) : null,
            projectLeader: data?.projectLeader?._id || null,
            financialController: data?.projectLeader?._id || null,
            team: data.team?.map(team => team?._id) || [],
            rateType: data?.rateType || null,
            currency: data?.currency || null,
            amount: data?.amount || null,
            description: data?.description || null,
            department: data?.department?._id || null,
            status: data?.status,
            inventory: data?.inventory?.map(item => ({
              item: item?.item,
              total: item?.total,
              minimumAmount: item?.minimumAmount
            }))
          }}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={12}>
              <Form.Item
                name="client"
                label={<span>{t("Client")}</span>}
                rules={[{ required: true, message: t("Please select a client") }]}
              >
                <CustomerSelect
                  customers={clientsArray.map(o => o.customer)}
                  branch={branchSel.clientBranch}
                  onChange={(id, branchId, customer) =>
                    setBranchSel({
                      clientBranch: branchId,
                      billTo:
                        (branchId && findBranch(customer, branchId)?.defaultBillTo) || "branch"
                    })
                  }
                />
              </Form.Item>
            </Col>
            {selectedClient?.branches?.length ? (
              <Col xs={24}>
                <CustomerBranchPicker
                  customer={selectedClient}
                  value={branchSel}
                  onChange={setBranchSel}
                  showBranchSelect={false}
                />
              </Col>
            ) : null}
            <Col xs={24} md={12}>
              <Form.Item
                name="department"
                label={<span>{t("Department")}</span>}
                rules={[{ required: true, message: t("Please select a department") }]}
              >
                <Select options={departments} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                name="projectName"
                label={<span>{t("Project Name")}</span>}
                rules={[{ required: true, message: t("Please enter project name") }]}
              >
                <Input type="text" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={t("Start Date")}
                name="startDate"
                rules={[
                  { required: true, message: t("Please select a start date") },

                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const endDate = getFieldValue("endDate");
                      if (!value || !endDate || value.isBefore(endDate)) {
                        return Promise.resolve();
                      }
                      return Promise.reject(t("Start date must be before the end date"));
                    }
                  })
                ]}
              >
                <DatePicker className="w-100" format="DD/MMM/YYYY" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label={t("End Date")}
                name="endDate"
                rules={[
                  { required: true, message: t("Please select an end date") },

                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const startDate = getFieldValue("startDate");
                      if (!value || !startDate || value.isAfter(startDate)) {
                        return Promise.resolve();
                      }
                      return Promise.reject(t("End date must be after start date"));
                    }
                  })
                ]}
              >
                <DatePicker className="w-100" format="DD/MMM/YYYY" />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item name="priority" label={t("Priority")}>
                <Select
                  options={[
                    { value: "LOW", label: t("Low") },
                    { value: "MEDIUM", label: t("Medium") },
                    { value: "HIGH", label: t("High") }
                  ]}
                />
              </Form.Item>
            </Col>
            <Col xs={24}>
              <Form.Item name="currency" label={t("Currency")}>
                <Select options={currenciesArray} />
              </Form.Item>
            </Col>
            <Col xs={24} md={8}>
              <Form.Item name="rateType" label={t("Rate Type")}>
                <Select
                  options={[
                    { value: "HOURLY", label: t("Hourly") },
                    { value: "FIXED", label: t("Fixed") }
                  ]}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={16}>
              <Form.Item name="amount" label={<span>{t("Rate")}</span>}>
                <Input type="number" />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item name="projectLeader" label={t("Project Leader")}>
                <Select options={employees} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item name="financialController" label={t("Financial Controller")}>
                <Select options={employees} />
              </Form.Item>
            </Col>
            <Col xs={24}>
              <Form.Item name="team" label={t("Team")}>
                <Select mode="tags" options={employees} />
              </Form.Item>
            </Col>
            <Col xs={24}>
              <Form.Item name="description" label={t("Description")}>
                <TextArea rows={4} />
              </Form.Item>
            </Col>
            <Col xs={24}>
              <Form.Item name="files" label={t("Files")}>
                <DragUpload />
              </Form.Item>
            </Col>
            <Col xs={24}>
              <div className="mt-3">
                <h3>{t("Inventory")}</h3>
                <InventoryUsage inventoryList={inventoryList} form={form} />
              </div>
            </Col>
            <Col xs={24}>
              <Form.Item name="status" label={t("Status")} initialValue="JUST ADDED">
                <Select options={projectStatusArray} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      )
    }
  ];

  return (
    <div className="AddProjects">
      <MainButtonComp text="Edit" editBtn onClick={showModal} />
      <GeneralModal
        title={t("Edit Project")}
        onOk={() => form.submit()}
        open={isModalOpen}
        okText={t("Save")}
        onCancel={handleCancel}
        onChange={onChangetab}
        items={items}
      />
    </div>
  );
};

export default EditProjects;
